<wl-content-section [id]="id()" [theme]="theme()">
  <wl-logos-section
    [uid]="uid()!"
    [title]="title()!"
    [introduction]="introduction()!"
    [logos]="logos()!"
  />
</wl-content-section>
